// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jC9i","right":"styles_right__u_axl"};